var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import Flickity from 'flickity';
import PlayRepository from './PlayRepository.js';
import { helper } from "../../common/helper";
import MoreEpisodesImage from "./images/btn_more-episodes.svg";
import PlayIcon from "../../common/images/ic_play.svg";
import PlayOutlineImage from "../../common/images/logo_rtlplay.svg";
var RTLPlayPodcast = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLPlayPodcast, _LitElement);
  function RTLPlayPodcast() {
    var _this;
    _classCallCheck(this, RTLPlayPodcast);
    _this = _callSuper(this, RTLPlayPodcast);
    _this.language = 'lb';
    _this.isApp = false;
    _this.currentApp = '';
    _this.episodes = [];
    if (window.rtlsites) {
      _this.isApp = window.rtlsites.config.isApp;
      if (window.rtlsites.config.language !== 'lu') _this.language = window.rtlsites.config.language;
      _this.currentApp = window.rtlsites.config.currentApp;
    }
    return _this;
  }
  _createClass(RTLPlayPodcast, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLPlayPodcast.prototype), "connectedCallback", this).call(this);
      this.repo = new PlayRepository(this.lang);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this.repo.getEpisodesWithEmission(this.show).then(function (resp) {
        //console.log("getEpisodesWithEmission", resp);
        _this2.episodes = resp.episodes;
        _this2.emission = resp.emission;
      });
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(e, url, appurl) {
      helper.openPlayLink(url, appurl);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (!this.emission) return null;
      console.log("EPISODES", this.episodes, this.emission);
      var lastEpisodes = this.episodes.slice(0, 3);
      return html(_t || (_t = _`
            <div class="rtl-play-last-episodes__wrapper rtl-play-box--last-episodes">
                <div class="rtl-play-last-episodes__monster-container" style="background-image: url('${0}'); background-size: cover; background-position: center top; padding-bottom: 20px;">
                    <div class="rtl-play-last-episodes__bg-color"></div>

                    <div class="rtl-play-last-episodes__header">
                        <a href="https://play.rtl.lu" target="_blank">
                            <img class="rtl-play-last-episodes__logo-rtl-play" src="${0}" alt="Logo RTL PLay"/>
                        </a>

                        <a @click=${0} target="_blank">
                            <img class="rtl-play-last-episodes__btn-more" src="${0}" alt="Button more episodes "/>
                        </a>
                    </div>


                    <div class="rtl-play-last-episodes__podcast-container">
                        <a href="${0}" target="_blank"><img class="rtl-play-last-episodes__podcast-img" src="${0}"/></a>
                        <div class="rtl-play-last-episodes__podcast-infos">
                            ${0}
                        </div>
                    </div>

                    <div class="rtl-play-last-episodes__episodes-container">
                        ${0}
                    </div>
                </div>
            </div>
        `), this.emission.images.landscape, PlayOutlineImage, function (e) {
        return _this3._handleClick(e, _this3.emission._links.share, _this3.emission._links.app);
      }, MoreEpisodesImage, this.emission._links.share, helper.stockify(this.emission.covers.square, 180), this.emission.description, lastEpisodes.map(function (lastEpisode) {
        return html(_t2 || (_t2 = _`<div class="rtl-play-last-episodes__episodes" @click=${0}>
                                <div class="rtl-play-last-episodes__icon-container">
                                    <img class="rtl-play-last-episodes__icon" src="${0}" alt="icone play"/>
                                </div>

                                <div class="rtl-play-last-episodes__episodes-infos">
                                    <div class="rtl-play-last-episodes__episodes-name">${0}</div>
                                    <div class="rtl-play-last-episodes__episodes-text">${0}</div>
                                </div>
                            </div>`), function (e) {
          return _this3._handleClick(e, lastEpisode._links.share, lastEpisode._links.app);
        }, PlayIcon, lastEpisode.name, lastEpisode.description);
      }));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        lang: {
          type: String
        },
        show: {
          type: String
        },
        episodes: {
          type: Array
        },
        logo: {
          type: String
        },
        emission: {
          type: Object
        },
        currentApp: {
          type: String
        }
      };
    }
  }]);
  return RTLPlayPodcast;
}(LitElement);
export { RTLPlayPodcast as default };
window.customElements.define('rtl-play-podcast', RTLPlayPodcast);